import React from "react";
import Icon from "backpack-ui/dist/components/icon";
import Button from "../../Button";
import NavModal from "./NavModal";

class Mobile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isActive: false,
    };
  }

  setActive = (event) => {
    event.preventDefault();

    this.setState({
      isActive: true,
    });
  };

  setInactive = () => {
    this.setState({
      isActive: false,
    });
  };

  render() {
    const { className } = this.props;
    const { isActive } = this.state;

    return (
      <React.Fragment>
        <Button
          element="a"
          className={className}
          href="#footer"
          onClick={this.setActive}
        >
          <Icon.Menu label="Open navigation menu" />
        </Button>

        <NavModal
          isOpen={isActive}
          onRequestClose={this.setInactive}
        />
      </React.Fragment>
    );
  }
}

export default Mobile;
